const $ = require('jquery');

export class SnsChanger {

    public static changeShareUrl(tutorial: boolean = false): void {

        let url: string = '';
        if (tutorial) {
            url = window.location.href;
        }
        else {
            const type: string = (Math.random() < .5) ? 'a' : 'b';
            url = `https://bodoge.blue-puddle.com/analog_degital_bodoge/share_${type}.html`
        }

        $('.fb-share-button').attr('data-href', url);
        $('.btnRound--twitter, .btnRound--facebook, .btnRound--hatena, .btnRound--line, .btnCircle--twitter, .btnCircle--facebook').attr('data-url', url);
    }
    
}